import filterNav from '../../../modifiers/filterNav'
import links from '../../../links'
import constants from '../../../constants'
import getNotEmptyCosmeticsCategories from '../../getNotEmptyCosmeticsCategories'

import messages from './messages'


const { makeup: { categories: makeupCategories } } = constants.cosmeticsCategories
const { makeup: makeupTypes } = constants.cosmeticsProductTypes

const getMakeupTypes = ({ notEmptyTypes, withoutAll } = {}) => {
  const categories = [
    (
      !withoutAll && (
        { name: makeupCategories.all, title: messages.all, to: links.makeup }
      )
    ),
    ...(
      getNotEmptyCosmeticsCategories({
        root: constants.cosmeticsCategories.makeup.name,
        types: notEmptyTypes,
        categories: [
          {
            name: makeupCategories.palettes,
            title: messages.palettes,
            to: links.makeupPalettes,
            singleType: makeupTypes.palettes.palette,
          },
          {
            name: makeupCategories.face,
            title: messages.face,
            to: links.makeupFace,
            subCategories: [
              { name: makeupTypes.face.facePrimer, title: messages.facePrimer, to: links.makeupFacePrimer },
              { name: makeupTypes.face.concealer,  title: messages.concealer,  to: links.makeupConcealer },
              { name: makeupTypes.face.foundation,  title: messages.faceFoundation,  to: links.makeupFaceFoundation },
            ],
          },
          {
            name: makeupCategories.cheek,
            title: messages.cheek,
            to: links.makeupCheek,
            subCategories: [
              { name: makeupTypes.cheek.cheekBlush,     title: messages.cheekBlush,     to: links.makeupCheekBlush },
              { name: makeupTypes.cheek.cheekHighlight, title: messages.cheekHighlight, to: links.makeupCheekHighlight },
            ],
          },
          {
            name: makeupCategories.eye,
            title: messages.eye,
            to: links.makeupEye,
            subCategories: [
              { name: makeupTypes.eye.eyeMascara,   title: messages.mascara,      to: links.makeupEyeMascara },
              { name: makeupTypes.eye.eyebrow,      title: messages.eyebrow,      to: links.makeupEyeEyebrow },
              { name: makeupTypes.eye.eyeTreatment, title: messages.eyeTreatment, to: links.makeupEyeTreatment },
              { name: makeupTypes.eye.eyeLiner,     title: messages.eyeLiner,     to: links.makeupEyeEyeliner },
              { name: makeupTypes.eye.eyePrimer,    title: messages.eyePrimer,    to: links.makeupEyePrimer },
              { name: makeupTypes.eye.eyeshadow,    title: messages.eyeshadow,    to: links.makeupEyeEyeshadow },
            ],
          },
          {
            name: makeupCategories.lip,
            title: messages.lip,
            to: links.makeupLip,
            subCategories: [
              { name: makeupTypes.lip.lipLiner,  title: messages.lipLiners,  to: links.makeupLipLiner },
              { name: makeupTypes.lip.lipstick,  title: messages.lipstick,   to: links.makeupLipLipstick },
              { name: makeupTypes.lip.lipgloss,  title: messages.lipgloss,   to: links.makeupLipLipgloss },
            ],
          },
          {
            name: makeupCategories.tools,
            title: messages.tools,
            to: links.makeupTools,
            subCategories: [
              { name: makeupTypes.tools.brushes, title: messages.brushes, to: links.makeupToolsBrushes },
            ],
          },
        ],
      })
    ),
  ]

  // Remove "false" elements [ {..}, false, {..} ] -> [ {..}, {..} ]
  const filteredCategories = categories
    .filter((category) => Boolean(category))
    .map((category) => {
      const { subCategories } = category

      if (Boolean(subCategories)) {
        category.subCategories = subCategories.filter((subCategory) => Boolean(subCategory))
      }

      return category
    })

  return filterNav(filteredCategories, 'subCategories')
}


export default getMakeupTypes
